import { defineKey as T } from 'ha/i18n';
import { DEFAULT_CURRENCY } from 'ha/constants/Currencies';

interface Amounts {
  initial: number;
  maximum: number;
  minimum: number;
}

interface Messages {
  paymentRequestCreated: string;
  paymentRequestFailure: string;
}

export const AMOUNTS: Amounts = { initial: 100, maximum: 10000, minimum: 1 };
export const CURRENCY = DEFAULT_CURRENCY;
export const FORM_NAME = 'createPaymentRequest';
export const MESSAGES: Messages = {
  paymentRequestCreated: T('Success! Your payment request has been sent.'),
  paymentRequestFailure: T('Failed to create payment request'),
};
export const STATE_NAME = 'PaymentRequestsModule';
export const DATE_FORMAT_MODEL = 'YYYY-MM-DD';
export const DATE_FORMAT_VIEW = 'll';
